import { twMerge } from "tailwind-merge";
import classnames from "classnames";

export const twClassNames = (...classNames) => twMerge(classnames(...classNames));
